import { render, staticRenderFns } from "./driverWeeklyDetail.vue?vue&type=template&id=4358dfd2&scoped=true&"
import script from "./driverWeeklyDetail.vue?vue&type=script&lang=js&"
export * from "./driverWeeklyDetail.vue?vue&type=script&lang=js&"
import style0 from "./driverWeeklyDetail.vue?vue&type=style&index=0&id=4358dfd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4358dfd2",
  null
  
)

export default component.exports